import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material'
import react from 'react'
import { useAppSelector } from '../../../../store/hooks/hooks'
import './studentList.scss'


const StudentList = () => {
    const placementLists = useAppSelector((state: any) => state.admin.placements)
    return (
        <div className='m-2 outerListContainer pt-2 shadow'>
            <div className='innerContainerList p-3'>
                <h2 className='title'>Student List</h2>
                <h3 className='subTitle gray-color body-p'>Track and manage you students list.</h3>
                <TableContainer component={Paper} className="tableContainer">
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell >Placement Id</TableCell>
                                <TableCell align="right" >Student</TableCell>
                                <TableCell align="right" >Company Name</TableCell>
                                <TableCell align="right" >Role</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {placementLists.map((elm: any) => (
                                <TableRow
                                    key={elm.placement.Id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row" className='font-weight-700'>
                                        {elm.placement.Id}
                                    </TableCell>
                                    <TableCell align="right">
                                        <div className='flex flex-column'>
                                            <span className='font-weight-700'>
                                                {elm.user.first_name} {elm.user.last_name}
                                            </span>
                                            <span className='gray-color'>
                                                {elm.user.email}
                                            </span>
                                        </div>
                                    </TableCell>
                                    <TableCell align="right" className='gray-color'>{elm.placement.CompanyName}</TableCell>
                                    <TableCell align="right" className='gray-color'>{elm.placement.JobRoles}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

        </div>
    )

}
export default StudentList